<template>
  <div class="mt-3 mb-1">
    <b-navbar>
      <b-button
            v-if="hasBack"
            size="sm"
            :variant="backButtonType"
            class="my-2 mr-2 my-sm-0"
            @click="back"
            ><i class="fa fa-arrow-left"></i></b-button
          >
      <b-navbar-brand v-if="title" class="title-text" href="javascript:void()">
        {{ title }}
      </b-navbar-brand>

      <b-navbar-nav class="ml-auto">
        <b-modal
          header-class="header-nipige-class"
          id="dateRange"
          size="sm"
          ref="date-range"
          centered
          hide-footer
        >
          <b-input class="mb-2" type="date" v-model="startDate"></b-input>
          <b-input type="date" v-model="endDate"></b-input>
          <div class="text-center mt-2">
            <b-button
              @click="findButtonClick()"
              class="my -0 main-navigation-button w-47 mr-2"
              variant="primary"
              >Find</b-button
            >
          </div>
        </b-modal>
        <b-nav-form>
          <b-form-select
            v-if="hasRadio"
            class="mr-2"
            id="btn-radios-2"
            v-model="radioInput"
            :options="radioOptions"
            buttons
            :disabled="disableKey"
            button-variant="outline-light"
            size="md"
            name="radio-btn-outline"
            @change="radioChangeInput"
          ></b-form-select>

          <b-form-select
            v-if="
              this.$route.fullPath == '/partner' ||
              this.$route.name == 'ChildPartnerList'
            "
            class="mr-2"
            id="type"
            :options="hasfilterOptions.map((e) => e.label)"
            v-model="selectedOption"
            :selected="selectedOption"
            @input="selectedOptionValue"
          ></b-form-select>
          <b-input-group-append size="sm" class="mb-2 mt-2">
            <b-form-input
              v-if="hasSearch"
              size="sm"
              class="mr-sm-4 height"
              placeholder="Search"
              v-model="searchQuery"
            ></b-form-input>
            <b-img
              v-if="hasSearch && searchQuery == ''"
              :src="`search.png`"
              class="image-size"
            ></b-img>
            <b-img
              v-if="hasSearch && searchQuery != ''"
              :src="`search_cross.png`"
              @click="searchQuery = ''"
              class="image-size"
            ></b-img>
          </b-input-group-append>
          <!-- <b-button
                v-if="hasSearch && this.$route.fullPath != '/partner'"
                size="sm"
                variant="success"
                class="my-2 mr-2 my-sm-0"
                @click="searchQuery = ''"
                >Clear</b-button
              > -->
          <b-button
            v-if="hasCreate"
            size="sm"
            class="my-2 mr-2 my-sm-0 ml-3 btn-clr"
            @click="create"
            >{{ createButtonText }}</b-button
          >
          <b-button
            v-if="hasExport"
            size="sm"
            :variant="exportButtonType"
            :class="
              hasExport && this.$route.fullPath == '/commission'
                ? 'my-2 mr-3 ml-3 my-sm-0'
                : 'my-2 mr-2 my-sm-0'
            "
            @click="exportData"
            >{{ exportButtonText }}</b-button
          >
          <b-button
            v-if="hasReload"
            size="sm"
            class="load-btn"
            :class="
              hasReload && this.$route.fullPath == '/payment-history'
                ? 'my-2 ml-3 my-sm-0'
                : 'my-2 mr-2 my-sm-0' ||
                  (hasReload && this.$route.name == 'ChildPartnerList')
                ? 'my-2 ml-3 mr-2 my-sm-0'
                : 'my-2 mr-2 my-sm-0'
            "
            @click="reloadData"
            :disabled="isLoading"
          >
            <span
              v-if="isLoading"
              class="fa fa-refresh fa-spin"
              style="font-size: 15px"
            />
            <span v-else class="fa fa-refresh" style="font-size: 15px" />
          </b-button>
        </b-nav-form>
      </b-navbar-nav>
    </b-navbar>
  </div>
</template>

<script>
import ebSelect from "@/components/FormElements/Select.vue";
export default {
  components: {
    ebSelect,
  },
  data() {
    return {
      searchQuery: "",
      radioInput: 1,
      startDate: "",
      selectedOption: "SELLER",
      endDate: "",
    };
  },
  props: {
    hasfilterOptions: {
      type: Array,
      default: () => {
        [];
      },
    },
    hasRadio: {
      type: Boolean,
      default: false,
    },
    disableKey: {
      type: Boolean,
      default: false,
    },

    radioOptions: {
      type: Array,
      default: () => {
        [];
      },
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    hasSearch: {
      type: Boolean,
      default: true,
    },
    hasOption: {
      type: Boolean,
      default: false,
    },
    hasCreate: {
      type: Boolean,
      default: true,
    },
    hasBack: {
      type: Boolean,
      default: true,
    },
    hasExport: {
      type: Boolean,
      default: false,
    },
    hasSelect: {
      type: Boolean,
      default: true,
    },
    hasReload: {
      type: Boolean,
      default: true,
    },
    cleanSearchOnReload: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    createButtonText: {
      type: String,
      default: "Create",
    },
    // backButtonText: {
    //   type: String,
    //   default: "Back",
    // },
    exportButtonText: {
      type: String,
      default: "Export",
    },
    // createButtonType: {
    //   type: String,
    //   default: "success",
    // },
    backButtonType: {
      type: String,
      default: "light",
    },
    exportButtonType: {
      type: String,
      default: "success",
    },
  },
  methods: {
    selectedOptionValue() {
      this.hasfilterOptions.map((e) => {
        if (e.label == this.selectedOption) {
          this.$emit("select-query", e.value);
        }
      });
    },
    findButtonClick() {
      let e = {
        startDate: this.startDate,
        endDate: this.endDate,
      };
      this.$emit("dateRangeEmit", e);
      this.$refs["date-range"].hide();
    },
    radioChangeInput(e) {
      if (e == "custom") {
        this.$refs["date-range"].show();
      } else {
        this.$emit("radioChangeInputEmit", e);
      }
    },
    create: function () {
      this.$emit("create-press");
    },
    back: function () {
      this.$emit("back-press");
    },
    exportData() {
      this.$emit("onExport");
    },
    clearSearch: function () {
      this.searchQuery = "";
    },
    reloadData: function () {
      if (this.cleanSearchOnReload) {
        this.clearSearch();
      }
      this.$emit("reload-data");
    },
  },
  watch: {
    searchQuery() {
      this.$emit("search-query", this.searchQuery);
    },
  },
};
</script>

<style scoped>
.title-text {
  font-size: 18px;
  font-weight: 500;
}
.header-nipige-class {
  background-color: #737cf4;
  border-radius: 10px 10px 0px 0px;
}
.btn-clr {
  background-color: #48AA43;
  border: 1px solid #48AA43;
}
.load-btn {
  background-color: #34a853;
  border: 1px solid #34a853;
}
.modal-title {
  font-size: 15px;
  color: white;
  text-align: center;
  margin-left: 40%;
}
.modal-content {
  border-radius: 10px 10px 10px 10px;
}
.height {
  height: 32px;
  border-radius: 20px;
  min-width: 210px;
}
.margin-right {
  margin-right: 30px;
}
.image-size {
  height: 16px;
  width: 16px;
  margin-top: 7px;
  cursor: pointer;
  margin-left: -57px;
}
</style>
